import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { ErrorAlertIcon as ErrorIcon, SupportStrokeIcon } from "../../assets/icons";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { useSupportSheet } from "../../components/SupportSheet";
import { useStore } from "../../store/globalState";
import { FUND_REQUEST_ROUTES } from "../../constants";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { Navbar } from "../../components/Navbar";

/**
 * Gallery-safe: shown when a fund-request intention cannot be taken.
 */
export const RequestAlreadyFulfilledPage = memo(() => {
  const { t } = useTranslation("fund-request");
  const { theme } = useStore();
  const navigate = useNavigate();
  const { openSupport, supportSheet } = useSupportSheet("fund-request");

  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;

  return (
    <>
      <AuraLayout colorConfig={colorConfig} className="need-help-header flow-landing-page">
        <Layout.Header>
          <Navbar
            title={t("common.needHelp")}
            align="right"
            noBackButton
            color={title}
            onIconClick={openSupport}
            icon={
              <SupportStrokeIcon
                size={35}
                colors={[backgroundIcon, backgroundIcon]}
                glyphColor={iconColors[0]}
              />
            }
          />
        </Layout.Header>
        <Layout.Content className="landing-section flow-hero-section flow-hero-section--with-header">
          <ScrollFadeIndicator color={colorConfig.bodyCopy} />
          <section className="flow-hero">
            <FlowHeroMark backgroundIcon={backgroundIcon}>
              <ErrorIcon size={60} colors={iconColors} />
            </FlowHeroMark>
            <section className="landing-container">
              <PageTitle
                highlight={t("error.requestUnavailableTitle")}
                highlightColor={title}
                secudnary=""
                secudnaryColor={title}
              />
              <BodyCopy textColor={bodyCopy}>
                {t("error.requestUnavailableMessage")}
              </BodyCopy>
            </section>
          </section>
        </Layout.Content>
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={() => navigate(FUND_REQUEST_ROUTES.TRANSACTIONS)}
            >
              {t("error.goToApp")}
            </Button>
          </section>
        </Layout.Footer>
      </AuraLayout>
      {supportSheet}
    </>
  );
});
